import { useEffect } from 'react';
// import { withRouter } from "react-router-dom"; // ❌ Se elimina, ya no existe en v6
import { useLocation } from 'react-router-dom'; // ✅ Hook correcto

function ScrollToTop() {
  const location = useLocation(); // ✅ Hook que reemplaza history.listen

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]); // ✅ Se ejecuta cuando cambia el path

  return null;
}

export default ScrollToTop; // ✅ Ya no necesitas withRouter
